import React from 'react';

export default function MainContent(){
    return (
      <div className='main'>
        <h1 className='facts'>Fun facts about Luna</h1>
        <ul>
          <li>Was born March 29, 2018</li>
          <li>Was born in a home where her mother was being fostered through APA!</li>
          <li>Has well over 100K stars on every platform</li>
          <li>Prefers floor scoops</li>
          <li>Powers thousands of enterprises, including Aurora's Italian Bistro</li>
        </ul>
      </div>
    );
  }